import { put, select, takeLatest } from 'redux-saga/effects'
import { TabConstants } from '../../../components/tabs/Tabs.constants'
import { getHospitalNotifySelector } from '../../procedures/hospitalNotify/selectors'
import { IHospitalNotifyState } from '../../procedures/hospitalNotify/store/hospitalNotify.types'
import { getPatientTimelineSelector } from '../selectors/patientTimeline.selector'
import { saveTimelineItems, setActivityLog } from '../store/timeline.actions'
import { TimelineConstants } from '../store/timeline.constants'
import { IItem, ITimelineState } from '../store/timeline.types'
import { generateClientCorrelationId } from '../../nemsisData/utils/customElements.util'
import { getProcedureStateSelector } from '../../../components/procedure/selectors'

export function* addHospitalNotifyItem() {
  const timeline: ITimelineState = yield select(getPatientTimelineSelector)
  const { items } = timeline
  const { nemsisCodeOptions } = yield select(getProcedureStateSelector)

  const hospitalNotifyState: IHospitalNotifyState = yield select(getHospitalNotifySelector)
  const { pta, method, addToTimeline, key, time, date, assessedBy, comments, isEkgImport } = hospitalNotifyState
  if (addToTimeline) {
    const clientCorrelationId = generateClientCorrelationId(
      nemsisCodeOptions,
      TimelineConstants.HOSPITAL_NOTIFY_PROCEDURE,
      method?.name || '',
      {
        filter1: null,
        filter2: null,
        filter3: null,
      },
      key
    )
    const index = items.findIndex((item) => item.key === key)
    const dateTime = new Date(date || 0)
    if (time) {
      if (time.split(':').length >= 3) dateTime.setSeconds(+time.split(':')[2])
      dateTime.setMinutes(+time.split(':')[1])
      dateTime.setHours(+time.split(':')[0])
    }
    const item: IItem = {
      key: key,
      clientCorrelationId,
      grid: true,
      labelHeaderFlag: pta ? 'PTA' : '',
      labelHeader: time,
      subHeader: date,
      itemType: 'Procedures',
      event: 'Hospital Notify',
      eventSubHeader: `By ${assessedBy?.name || ''},
      Comments: ${comments}.`,
      rowActionType: TimelineConstants.SET_HOSPITAL_NOTIFY_PROCEDURE_ITEM,
      defaultHref: TabConstants.HOSPITAL_NOTIFY_PROCEDURE,
      date: dateTime,
      ...(isEkgImport && { isEkgImport: isEkgImport }),
    }
    if (index !== -1) {
      items[index] = item
    } else {
      items.push(item)
    }
    yield put(setActivityLog(items))
    yield put(saveTimelineItems())
  }
}

export function* addHospitalNotifyItemSaga() {
  yield takeLatest([TimelineConstants.ADD_HOSPITAL_NOTIFY_ITEM], addHospitalNotifyItem)
}
